// extracted by mini-css-extract-plugin
module.exports = {"MiniHero":"styles_MiniHero__yrKPs","height":"styles_height__Daa9H"};